import React, { useEffect, useMemo, memo } from 'react';

import Page from '@components/Page';
import { Text, Row, Col, Tag, Loader, Breadcrumb } from '@printi/printi-components';
import { useRouter } from 'next/router';

import useFetchTutorial from '../useFetchTutorial';
import * as S from './TutorialItem.styles';

const TutorialItem = () => {
  const router = useRouter();
  const { slug } = router.query;
  const { fetchTutorialContent, tutorialContent, tutorialContentLoading } = useFetchTutorial();

  useEffect(() => {
    fetchTutorialContent(slug);
  }, [fetchTutorialContent, slug]);

  const breadcrumb = useMemo(
    () => [
      {
        label: 'Home',
        path: '/',
      },
      {
        label: 'Tutoriais',
        path: '/tutoriais',
      },
      {
        label: tutorialContent ? tutorialContent.title : '',
      },
    ],
    [tutorialContent],
  );

  const youtube_parser = (url) => {
    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      return `https://www.youtube.com/embed/${match[2]}`;
    }
    return url;
  };

  return (
    <Page>
      {tutorialContentLoading && <Loader size="medium" wrapper="15rem" />}
      {!tutorialContentLoading && tutorialContent && (
        <>
          <Row>
            <Col>
              <Breadcrumb pages={breadcrumb} />
              <Text size="xlg" transform="uppercase" weight="bold">
                Tutoriais
              </Text>
            </Col>
          </Row>
          <Row>
            <Col>
              {tutorialContent.tags.map((name) => (
                <Tag size="large" color="info" kind="filled">
                  {name}
                </Tag>
              ))}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Text as="h1" align="center" transform="capitalize" size="xxlg">
                {tutorialContent.title}
              </Text>
            </Col>
          </Row>
          <Row>
            <Col>
              <S.StyledIframe
                title={tutorialContent.title}
                width="800"
                height="515"
                src={`${youtube_parser(tutorialContent.video.url)}`}
                frameBorder="0"
                allowFullScreen
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <S.TutorialItemContent dangerouslySetInnerHTML={{ __html: tutorialContent.content }} />
            </Col>
          </Row>
        </>
      )}
    </Page>
  );
};

export default memo(TutorialItem);
